/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RecordForRelated = {
  id: number;
  title: string | null;
  /**
   * 녹음/녹화 종료 시간
   */
  rec_date: string;
  source: RecordForRelated.source;
  duration?: number | null;
  /**
   * 레코드 생성시간
   */
  created_at: string;
  readonly start_date: string;
};

export namespace RecordForRelated {
  export enum source {
    ZOOM = 'zoom',
    GOOGLE_MEET = 'google_meet',
    TEAMS_MEET = 'teams_meet',
    PHONE_CALL = 'phone_call',
    VOICE_RECORDER = 'voice_recorder',
    SCREEN_RECORDER = 'screen_recorder',
    MANUAL_UPLOAD = 'manual_upload',
  }
}
